// extracted by mini-css-extract-plugin
module.exports = {"responsavel":"Registro_responsavel__3miz0","foto":"Registro_foto__3AbIq","iconeUsuario":"Registro_iconeUsuario__1wp2_"};